const baseUrl = "/srv/";
const insBaseUrl = "/ins/";

/*const baseUrl = "http://localhost:8000/";
const insBaseUrl = "http://localhost:8001/";*/

export const config = {
  apiUrl: baseUrl + "api/",
  authUrl: baseUrl + "auth/",
  insApiUrl: insBaseUrl + "api/",
  insAuthUrl: insBaseUrl + "auth/"
};
